import { Row, Col, Card } from 'react-bootstrap';
import { FaWallet, FaChalkboardTeacher, FaPlayCircle, FaCalendarCheck } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import '../admin/Dashboard.css';

export default function StudentDashboard() {
  const { user } = useAuth();
  const wallet = Number(user?.profile?.wallet_balance ?? 0);

  return (
    <>
      <h3 className="mb-4">Welcome, {user?.profile?.name || 'Student'}</h3>

      <Row>
        <Col md={3}>
          <Card as={Link} to="/student/wallet" className="shadow mb-3 text-decoration-none">
            <Card.Body className="custom-profit">
              <FaWallet size={30} className="mb-2 text-white" />
              <Card.Title className="text-white">Wallet Balance</Card.Title>
              <h4 className="text-white">₹{wallet.toFixed(2)}</h4>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card as={Link} to="/student/teachers" className="shadow mb-3 text-decoration-none">
            <Card.Body className="custom-teacher">
              <FaChalkboardTeacher size={30} className="mb-2 text-white" />
              <Card.Title className="text-white">Browse Teachers</Card.Title>
              <h6 className="text-white">Find your tutor</h6>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card as={Link} to="/student/bookings" className="shadow mb-3 text-decoration-none">
            <Card.Body className="custom-pending">
              <FaPlayCircle size={30} className="mb-2 text-white" />
              <Card.Title className="text-white">My Bookings</Card.Title>
              <h6 className="text-white">Demos and hires</h6>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card as={Link} to="/student/classes" className="shadow mb-3 text-decoration-none">
            <Card.Body className="custom-student">
              <FaCalendarCheck size={30} className="mb-2 text-white" />
              <Card.Title className="text-white">My Classes</Card.Title>
              <h6 className="text-white">Attendance</h6>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card className="shadow mt-4">
        <Card.Body>
          <Card.Title>Getting started</Card.Title>
          <ol className="mb-0">
            <li>Browse approved teachers and pick one that matches your subject/grade.</li>
            <li>Book a demo class — the month's fee moves into your wallet and is held.</li>
            <li>After the demo, <strong>hire</strong> the teacher (fee releases to the platform for settlement) or <strong>reject</strong> (full amount returns to your wallet).</li>
          </ol>
        </Card.Body>
      </Card>
    </>
  );
}
